import {API_BASE_URL} from "../clases/request";

export default class ListsOperations {

    static getDeviceList(onDelete, forbidden, token) {
        return [

            {
                iconName: "trashR", className: "", popupTitle: "حذف دستگاه", isLinkWithId: false, onClick: (event) => {
                    onDelete(event);
                },
            },

            {
                iconName: "forbidden",
                className: "",
                popupTitle: "لاگ دستگاه",
                isLinkWithId: false,
                onClick: (event) => {
                    forbidden(event);
                },
            },

            {
                iconName: "note",
                className: "",
                linkKey: "id",
                isLinkWithId: true,
                popupTitle: "جزئیات دستگاه",
                link: "/admin/device/list/details",
                linkOpenInNewTab: false,
                onClick: (event) => {
                },
            }, {
                iconName: "scan-barcode",
                className: "",
                isLinkWithId: false,
                popupTitle: "دانلود بارکد",
                link: `${API_BASE_URL}/store-house/get-label/SERIAL/${token}`,
                linkOpenInNewTab: false,
                downloadQRCode: true,
                onClick: (event) => {

                },
            }, {
                iconName: "document-text",
                className: "",
                linkKey: "id",
                isLinkWithId: true,
                popupTitle: "لاگ دستگاه",
                link: "/admin/device/list/log",
                linkOpenInNewTab: false,
                onClick: (event) => {
                },
            },]
    }

    static getStorehouseList(onDelete, ontick, token, onEdite) {

        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "حذف دستگاه",
                isLinkWithId: false,
                onClick: (event) => {
                    onDelete(event);
                },
            },
            {
                iconName: "tick",
                className: "",
                popupTitle: "فعال کردن دستگاه",
                isLinkWithId: false,
                onClick: (event) => {
                    ontick(event);
                },
            },
            {
                iconName: "scan-barcode",
                className: "",
                isLinkWithId: false,
                popupTitle: "دانلود بارکد",
                link: `${API_BASE_URL}/store-house/get-label/SERIAL/${token}`,
                linkOpenInNewTab: false,
                downloadQRCode: true,
                onClick: (event) => {

                },
            },
            {
                iconName: "edits",
                className: "",
                popupTitle: "ویرایش دستگاه",
                isLinkWithId: false,
                onClick: (event) => {
                    onEdite(event);
                },
            },
        ]
    }

    static getAdminsList(onDelete, onEdite) {
        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "ویرایش مدیر",
                isLinkWithId: false,
                onClick: (event) => {
                    onDelete(event);

                },
            },
            {
                iconName: "note",
                className: "",
                popupTitle: "لاگ مدیر",
                isLinkWithId: true,
                linkOpenInNewTab: false,
                link: "/admin/user/admins/log",
                linkKey: "id",
                onClick: (event) => {
                },
            },
            {
                iconName: "user-edit",
                className: "",
                popupTitle: "ویرایش مدیر",
                isLinkWithId: false,
                onClick: (event) => {
                    onEdite(event);

                },
            },
        ]
    }

    static getClientList(onDelete, onEdite) {
        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "حذف مشتری",
                isLinkWithId: false,
                onClick: (event) => {

                    onDelete(event);

                },
            },
            {
                iconName: "user-edit",
                className: "",
                popupTitle: "ویرایش مشتری",
                isLinkWithId: false,
                onClick: (event, id) => {

                    onEdite(event);


                },
            },
            {
                iconName: "document-text",
                className: "",
                linkKey: "id",
                isLinkWithId: true,
                popupTitle: "جزئیات کاربر",
                link: "/admin/user/clients/details",
                linkOpenInNewTab: false,
                onClick: (event) => {
                },
            },
        ]
    }

    static getSystemList(onDelete) {
        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "حذف گارانتی",
                isLinkWithId: false,
                onClick: (event) => {
                    onDelete(event);

                },
            },
        ]
    }

    static getDeviceModelsList(onDelete, onEdite, onJson) {
        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "حذف مدل",
                isLinkWithId: false,
                onClick: (event) => {
                    onDelete(event);

                },
            },
            {
                iconName: "code-circle",
                className: "",
                isLinkWithId: false,
                popupTitle: "فایل نمونه",
                onClick: (event) => {
                    onJson(event)
                },
            },
            {
                iconName: "document-text",
                className: "",
                linkKey: "id",
                isLinkWithId: true,
                popupTitle: "جزئیات مدل",
                link: "/admin/device/models/details",
                linkOpenInNewTab: false,
                onClick: (event) => {
                },
            },
            {
                iconName: "edits",
                className: "",
                popupTitle: "ویرایش مدل",
                link: "/admin/device/models/edit",
                linkKey: "id",
                isLinkWithId: true,
                onClick: (event) => {


                },
            },
        ]
    }

    static getDeviceServiceList(onDelete, onEdit) {
        return [
            {
                iconName: "trashR",
                className: "",
                popupTitle: "حذف خدمات",
                isLinkWithId: false,
                onClick: (event) => {
                    onDelete(event);

                },
            },
            {
                iconName: "edits",
                className: "",
                popupTitle: "ویرایش خدمات",
                isLinkWithId: false,
                onClick: (event) => {
                    onEdit(event)

                },
            },
            {
                iconName: "document-text",
                className: "",
                linkKey: "id",
                isLinkWithId: true,
                popupTitle: "جزئیات خدمات",
                link: "/admin/device/Service/details",
                linkOpenInNewTab: false,
                onClick: (event) => {
                },
            },
        ]
    }

    static getTransactionList(onDownloadClick) {
        return [
            {
                iconName: "barcode",
                className: "",
                isLinkWithId: false,
                popupTitle: "دانلود فاکتور",
                link: ``,
                linkOpenInNewTab: false,
                downloadQRCode: true,
                onClick: onDownloadClick,
            },
        ]
    }
}